import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import { toast } from '../components/ui/Toast';

export interface AplicacionDTO {
  id: string;
  nombre: string;
  is_active: boolean;
}

export function useAplicaciones() {
  return useQuery({
    queryKey: ['aplicaciones'],
    queryFn: async () => {
      const res = await api.get<{ data: AplicacionDTO[] }>('/aplicaciones');
      return res.data.data;
    },
  });
}

export function useCreateAplicacion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { nombre: string }) => {
      const res = await api.post<{ data: AplicacionDTO }>('/aplicaciones', data);
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['aplicaciones'] });
      toast('success', 'Categoría creada');
    },
  });
}

export function useUpdateAplicacion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, nombre }: { id: string; nombre: string }) => {
      const res = await api.put<{ data: AplicacionDTO }>(`/aplicaciones/${id}`, { nombre });
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['aplicaciones'] });
      toast('success', 'Categoría actualizada');
    },
  });
}

export function useDeleteAplicacion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/aplicaciones/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['aplicaciones'] });
      toast('success', 'Categoría eliminada');
    },
  });
}
